import {
    Button,
    FormControlLabel,
    IconButton,
    MuiThemeProvider,
    TextField
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import { areAnyValuesEmpty } from 'components/Common/Utils/BaseUtils';
import { isNotBlank } from 'components/Common/Utils/StringUtils';
import {
    PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME,
    PRIMARY_BUTTON_LIGHT_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import { isEqual, pick } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PrimarySwitch } from 'theme/CommonTheme';
import * as actions from '../../../store/actions';
import { MACROPOINT } from '../../../store/actions/types';
import AuthenticationCredentials from '../macropointConfig/carrierConfig/AuthorizationCredentials';
const CarrierConfig = (props) => {
    const {
        saveCarrierConfig,
        carrierConfigExist,
        getCarrierConfig,
        session,
        updateCarrierConfig,
        enableConnectionOperation,
        carrierConfigObj,
        resetCarrierConfig,
        type,
        selectedAccount
    } = props;

    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isEditingConfig, setIsEditingConfig] = useState(false);
    const [carrierConfig, setCarrierConfig] = useState(carrierConfigObj);
    const initialCarrierConfig = useRef(null);
    useEffect(() => {
        getCarrierConfig(type, selectedAccount);
        setIsSaveEnabled(false);
    }, []);

    useEffect(() => {
        setCarrierConfig(carrierConfigObj);
        initialCarrierConfig.current = carrierConfigObj;
    }, [carrierConfigObj]);

    useEffect(() => {
        return () => {
            resetCarrierConfig();
        };
    }, []);

    const handleCarrierConfigChange = (event, newValue) => {
        const name = event?.target?.name;
        if (['carrierScac', 'carrierMc', 'carrierDot', 'macroPointId'].includes(name)) {
            setCarrierConfig({
                ...carrierConfig,
                [name]: event?.target?.value
            });
        } else if (name === 'enabled') {
            setCarrierConfig({
                ...carrierConfig,
                enabled: newValue
            });
        }
        setIsSaveEnabled(true);
    };

    const handleEditMode = () => {
        setIsEditingConfig(!isEditingConfig);
        setIsSaveEnabled(false);
        enableConnectionOperation?.(!isEditingConfig);
        setCarrierConfig(initialCarrierConfig.current);
    };

    const handleAuthenticationCredentialUpdate = (updatedCredentials) => {
        const credentialsChanged =
            Object.keys(updatedCredentials).length !==
                Object.keys(carrierConfig?.authentication_credentials)?.length ||
            Object.entries(updatedCredentials).some(
                ([key, value]) => carrierConfig?.authentication_credentials[key] !== value
            );

        if (credentialsChanged) {
            setIsSaveEnabled(true);
        }

        setCarrierConfig({
            ...carrierConfig,
            authentication_credentials: updatedCredentials
        });
    };

    const isCarrierConfigValid = () => {
        const propNames = [
            'carrierScac',
            'carrierMc',
            'carrierDot',
            'macroPointId',
            'authentication_credentials'
        ];
        return !isEqual(
            pick(initialCarrierConfig.current, propNames),
            pick(carrierConfig, propNames)
        );
    };

    const handleCancelEdit = () => {
        setIsEditingConfig(false);
        enableConnectionOperation?.(true);
        setCarrierConfig(initialCarrierConfig.current);
        setIsSaveEnabled(false);
    };

    const saveCarrierConfiguration = () => {
        if (carrierConfig?.id) {
            updateCarrierConfig(type, carrierConfig);
        } else {
            const newCarrierConfig = {
                ...carrierConfig,
                accountId: session.accountUuid,
                carrierName: session.accountName
            };
            setCarrierConfig(newCarrierConfig);
            saveCarrierConfig(type, newCarrierConfig);
        }
        setIsEditingConfig(false);
        setIsSaveEnabled(false);
        enableConnectionOperation?.(false);
    };

    const validateFields = () => {
        let carrierConfigInvalid = false;
        const hasCarrierIdentifier = [
            carrierConfig?.carrierScac,
            carrierConfig?.carrierMc,
            carrierConfig?.carrierDot
        ].some((value) => isNotBlank(value));
        const hasMacroPointId = type !== MACROPOINT || isNotBlank(carrierConfig?.macroPointId);
        if (
            !areAnyValuesEmpty(carrierConfig?.authentication_credentials) &&
            hasCarrierIdentifier &&
            hasMacroPointId &&
            isCarrierConfigValid()
        ) {
            return carrierConfigInvalid;
        } else {
            carrierConfigInvalid = true;
        }
        return carrierConfigInvalid;
    };

    return (
        <>
            <div className="col-sm-6" style={{ fontWeight: 700 }}>
                CARRIER CONFIG
            </div>
            <div className="col-sm-6 d-flex justify-content-end">
                <IconButton
                    id={'editIcon'}
                    size="small"
                    onClick={handleEditMode}
                    disabled={!carrierConfigExist}
                >
                    <CreateIcon fontSize="small" />
                </IconButton>
            </div>
            <div className="col-sm-6">
                <TextField
                    fullWidth
                    name="carrierScac"
                    label="Carrier Scac"
                    id="carrier_scac"
                    margin="normal"
                    variant="filled"
                    disabled={!isEditingConfig && carrierConfigExist}
                    value={carrierConfig?.carrierScac || ''}
                    onChange={handleCarrierConfigChange}
                />
            </div>
            <div className="col-sm-6">
                <TextField
                    fullWidth
                    name="carrierMc"
                    label="Carrier MC"
                    id="carrier_mc"
                    margin="normal"
                    variant="filled"
                    disabled={!isEditingConfig && carrierConfigExist}
                    value={carrierConfig?.carrierMc || ''}
                    onChange={handleCarrierConfigChange}
                />
            </div>
            <div className="col-sm-6">
                <TextField
                    fullWidth
                    name="carrierDot"
                    label="Carrier DOT"
                    id="carrier_dot"
                    margin="normal"
                    variant="filled"
                    disabled={!isEditingConfig && carrierConfigExist}
                    value={carrierConfig?.carrierDot || ''}
                    onChange={handleCarrierConfigChange}
                />
            </div>
            {type === MACROPOINT && (
                <div className="col-sm-6">
                    <TextField
                        fullWidth
                        name="macroPointId"
                        label="MacroPoint Id"
                        id="macro_point_id"
                        margin="normal"
                        variant="filled"
                        required
                        disabled={!isEditingConfig && carrierConfigExist}
                        value={carrierConfig?.macroPointId || ''}
                        onChange={handleCarrierConfigChange}
                    />
                </div>
            )}
            <div className="col-sm-6">
                <FormControlLabel
                    style={{ padding: '15px' }}
                    control={
                        <PrimarySwitch
                            name="enabled"
                            color="primary"
                            checked={carrierConfig?.enabled}
                            onChange={(event, newValue) =>
                                handleCarrierConfigChange(event, newValue)
                            }
                            disabled={carrierConfigExist}
                        />
                    }
                    label={carrierConfig?.enabled ? 'Enabled' : 'Disabled'}
                />
            </div>
            <div className="col-sm-12">
                <AuthenticationCredentials
                    updateAuthenticationCredentials={handleAuthenticationCredentialUpdate}
                    isEditingConfig={isEditingConfig}
                    carrierConfigExist={carrierConfigExist}
                    carrierConfig={carrierConfig}
                />
            </div>
            <div className="col-sm-12 d-flex justify-content-end" style={{ marginTop: '20px' }}>
                <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME}>
                    <Button
                        id={'cancel'}
                        size="small"
                        disabled={!isEditingConfig}
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </Button>
                </MuiThemeProvider>
                <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                    <Button
                        id={'save'}
                        size="small"
                        color="primary"
                        disabled={!isSaveEnabled || validateFields()}
                        onClick={saveCarrierConfiguration}
                    >
                        Save
                    </Button>
                </MuiThemeProvider>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        carrierConfigExist: state.carrierConfig.carrierConfigExist,
        session: state.session.sessionValue,
        carrierConfigObj: state.carrierConfig.carrierConfigObj,
        selectedAccount: state.accounts.selectedAccount
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetCarrierConfig: () => dispatch(actions.resetCarrierConfig()),
        getCarrierConfig: (...args) => dispatch(actions.getCarrierConfig(...args)),
        saveCarrierConfig: (...args) => dispatch(actions.saveCarrierConfig(...args)),
        updateCarrierConfig: (...args) => dispatch(actions.updateCarrierConfig(...args))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarrierConfig));
